<div class="card">
  <div class="card-body">
    <h5>{{ "Nhật ký xuất báo cáo" | translate }}</h5>
    <div class="">
      <div class="row align-items-end">
        <div class="form-group col-lg-3 col-md-6">
          <label for="validationCustom01">{{ "Từ khoá" | translate }}</label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="filter.search"
            placeholder="Nhập Từ khoá"
          />
        </div>
        <div class="form-group col-lg-3 col-md-6">
          <label for="statusFilter">{{ "Loại báo cáo" | translate }}</label>
          <select
            id="statusFilter"
            class="form-control"
            [(ngModel)]="filter.reportType"
          >
            <option value="">Tất cả</option>
            <option value="branch">Báo cáo CN</option>
            <option value="branch-device">Báo cáo số lượng loa CN</option>
            <option value="export-orders">Báo cáo đơn hàng</option>
            <option value="bass-noti">Báo cáo chuỗi cửa hàng</option>
            <option value="package-sub">Báo cáo gói dịch vụ</option>
            <option value="order-renew">Báo cáo gia hạn gói dịch vụ</option>
            <option value="export-workspace">Báo cáo giao dịch cửa hàng</option>
          </select>
        </div>

        <div class="col-lg-3 col-md-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Chọn khoảng ngày</mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
              <input
                matStartDate
                formControlName="start"
                placeholder="Ngày bắt đầu"
              />
              <input
                matEndDate
                formControlName="end"
                placeholder="Ngày kết thúc"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error
              *ngIf="range.controls.start.hasError('matStartDateInvalid')"
              >Invalid start date</mat-error
            >
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')"
              >Invalid end date</mat-error
            >
          </mat-form-field>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <button class="btn btn-primary" (click)="submitFilter()">
            <i class="ri-search-line"></i>
            {{ "PAGE.REPORT.Search" | translate }}
          </button>

          <button
            class="btn btn-dark ml-2"
            *ngIf="searching"
            (click)="clearFilter()"
          >
            <i class="ri-eraser-line"></i> {{ "FORM.Clear" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="mt-4 d-flex justify-content-end">
      <!-- <button class="btn btn-info ml-2" (click)="downloadTemplate()">
          <i class="ri-download-2-line"></i> Tải file mẫu
        </button> -->
      <!-- <button class="btn btn-info ml-2" (click)="checkSelectedOrders()">
                  <i class="ri-download-2-line"></i> Download dữ liệu đăng ký
              </button>
              <button class="btn btn-success ml-2" (click)="fileInput.click()">
                  <i class="ri-upload-2-line"></i> Import dữ liệu
              </button> -->
      <input
        type="file"
        #fileInput
        hidden
        (change)="onFileSelected($event)"
        accept=".xlsx, .xls"
      />
    </div>
    <div class="table-responsive mt-3">
      <table class="table table-bordered table-hover align-middle text-center">
        <thead class="bg-light">
          <tr>
            <th>#</th>
            <th>{{ "Tài khoản" | translate }}</th>
            <th>{{ "Vai trò" | translate }}</th>
            <th>{{ "IP" | translate }}</th>
            <th>{{ "Tên báo cáo" | translate }}</th>
            <th>{{ "Trạng thái" | translate }}</th>
            <th>{{ "Thời gian thực thi" | translate }}</th>
            <th>{{ "Ngày tạo" | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
            <td class="text-start">
              <div>{{ data?.full_name || "-" }}</div>
            </td>
            <td>
              <div>{{ data?.role_name || "-" }}</div>
            </td>
            <td>
              <div>
                {{ data?.ip_address || "-" }}
              </div>
            </td>
            <td>{{ data?.report_name || "Chưa có" }}</td>
            <td>
              <span
                class="px-3 py-2 badge"
                [ngClass]="{
                  'badge-success text-white': data?.status === 'success',
                  'badge-danger text-white': data?.status === 'failed'
                }"
              >
                {{ data?.status }}
              </span>
            </td>
            <td>{{ data?.execution_time }}</td>
            <td>{{ data?.created_at | date : "dd/MM/yyyy HH:mm" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <div
        class="col-sm-12 col-md-7 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật thông tin KH</h5>

    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData" (ngSubmit)="onUpdateCustomer()">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Tên tài khoản</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="accountName"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('accountName')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Mật khẩu</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="accountPassword"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('accountPassword')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Mã số thuế</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="taxCode"
                [ngClass]="{
                  'is-invalid': submitted && formData.get('taxCode')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Loại hóa đơn</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="invoice_type"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('invoice_type')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">Mẫu số</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="template_code"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('template_code')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Ký hiệu</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="invoice_series"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('invoice_series')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Loại hình kinh doanh</label
            >
            <div class="col-md-10">
              <select
                class="form-select form-control"
                formControlName="business_type"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('business_type')?.invalid
                }"
              >
                <option value="enterprise">Doanh nghiệp</option>
                <option value="household">Hộ kinh doanh</option>
              </select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            Đóng
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            Lưu
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentLink role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Liên kết thiết bị với đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Đơn hàng" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="data"
                [ngClass]="{ 'is-invalid': submitted && form.data.errors }"
                disabled
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số thiết bị cần gán" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="quantity"
                [ngClass]="{ 'is-invalid': submitted && form.quantity.errors }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listDevices"
                bindLabel="serial_number"
                bindValue="serial_number"
                formControlName="serial_number"
                [maxSelectedItems]="formData.get('quantity').value"
                [multiple]="true"
                placeholder="{{ 'Chọn thiết bị' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentDetail role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết đơn hàng Online</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Người nhận" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="customer_name"
                [ngClass]="{
                  'is-invalid': submitted && form.customer_name.errors
                }"
                disabled
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số điện thoại" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="phone"
                [ngClass]="{ 'is-invalid': submitted && form.phone.errors }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Địa chỉ" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="address"
                [ngClass]="{ 'is-invalid': submitted && form.address.errors }"
              />
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <!-- <button
              type="submit"
              class="btn btn-success btn-lg"
              style="width: 150px;"
            >
              {{'Lưu' | translate}}
            </button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #orderDetailModal role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div
    class="modal-body p-3"
    *ngIf="selectedOrder?.metadata?.accViettelInvoice"
  >
    <table class="table table-bordered table-sm">
      <tr>
        <th>Tên tài khoản</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.account_name }}</td>
      </tr>
      <tr>
        <th>Loại hình kinh doanh</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.business_type }}</td>
      </tr>
      <tr>
        <th>Ký hiệu hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.invoice_series }}</td>
      </tr>
      <tr>
        <th>Loại hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.invoice_type }}</td>
      </tr>
      <tr>
        <th>Mã số thuế</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.tax_code }}</td>
      </tr>
      <tr>
        <th>Mẫu hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.template_code }}</td>
      </tr>
    </table>
  </div>
</ng-template>
